import { alpha } from "@mui/material/styles";

import { type ComponentOverrides } from "theme/theme.types";

import { borderRadius, colors } from "design-tokens";

export const DIALOG_BACKDROP_COLOR = alpha(colors.neutrals[800], 0.4);

/**
 * **The overlay is reached from the dialog root, not a `MuiBackdrop` entry.** That would apply to
 * every `Backdrop`, and since MUI's `invisible` transparency is a *variant*, `styleOverrides`
 * would out-order it and paint this wash behind every `Menu`, `Popover` and `Select`.
 */
export const MuiDialog: ComponentOverrides["MuiDialog"] = {
  styleOverrides: {
    root: {
      "& .MuiBackdrop-root": {
        backgroundColor: DIALOG_BACKDROP_COLOR,
      },
    },
    paper: {
      borderRadius: borderRadius.lg,
    },
  },
};
